import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { Skeleton } from '@mui/material';
import * as S from './styles';

interface MetricItem {
  label: string;
  value: number;
}

interface PlayerMetricsProps {
  metrics: MetricItem[];
  title?: string;
  initialVisibleCount?: number;
  loading?: boolean;
}

const PlayerMetrics: React.FC<PlayerMetricsProps> = ({ 
  metrics, 
  title = "Métricas desta temporada",
  initialVisibleCount = 6,
  loading = false
}) => {
  const [showAll, setShowAll] = useState(false);
  
  const displayedMetrics = showAll 
    ? metrics 
    : metrics.slice(0, initialVisibleCount);
  
  const toggleShowAll = () => setShowAll(!showAll);
  
  if (loading) {
    return (
      <S.MetricsContainer>
        <S.Title>
          <Skeleton variant="text" width={250} height={36} />
        </S.Title>
        
        <S.MetricsList>
          {[...Array(initialVisibleCount)].map((_, index) => (
            <S.MetricItem key={index}>
              <S.MetricLabel>
                <Skeleton variant="text" width={120} height={24} />
              </S.MetricLabel>
              <S.MetricValue>
                <Skeleton variant="text" width={50} height={28} />
              </S.MetricValue>
            </S.MetricItem>
          ))}
        </S.MetricsList>
        
        <S.ShowMoreButton style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Skeleton variant="text" width={180} height={24} />
        </S.ShowMoreButton>
      </S.MetricsContainer>
    );
  }
  
  return (
    <S.MetricsContainer>
      <S.Title>{title}</S.Title>
      
      <S.MetricsList>
        {displayedMetrics.map((metric, index) => (
          <S.MetricItem key={index}>
            <S.MetricLabel>{metric.label}</S.MetricLabel>
            <S.MetricValue>{metric.value}</S.MetricValue>
          </S.MetricItem>
        ))}
      </S.MetricsList>
      
      {metrics.length > initialVisibleCount && (
        <S.ShowMoreButton onClick={toggleShowAll}>
          {showAll ? 'Ver menos informações' : 'Ver mais informações'}
          {showAll ? <FaChevronUp /> : <FaChevronDown />}
        </S.ShowMoreButton>
      )}
    </S.MetricsContainer>
  );
};

export default PlayerMetrics;